import { createClientLogger, logClientError } from '@/client/logging/client-logger';
import { useEffect, useState } from 'react';
import { isRequestCanceled } from '@/client/error-handling/is-request-canceled';
import { useMarketplaceApi } from '@/context/marketplace.context';

type UseProductsReportModalCompanyNameParams = {
    isShown: boolean;
    accessToken: string;
};

const productsReportCompanyNameLogger = createClientLogger({
    scope: 'products-report-company-name',
});

export const useProductsReportModalCompanyName = ({
    isShown,
    accessToken,
}: UseProductsReportModalCompanyNameParams): string => {
    const { aiProfileApi } = useMarketplaceApi();
    const [companyName, setCompanyName] = useState('');

    useEffect(() => {
        if (!isShown) {
            return;
        }

        const controller = new AbortController();

        aiProfileApi
            .get({ authToken: accessToken, signal: controller.signal })
            .then((aiProfileResponse) => {
                const storeName = aiProfileResponse.data?.storeName;
                setCompanyName(typeof storeName === 'string' ? storeName.trim() : '');
            })
            .catch((error: unknown) => {
                if (isRequestCanceled(error)) {
                    return;
                }

                logClientError({
                    logger: productsReportCompanyNameLogger,
                    message: '[client.products-report.company-name-load] Failed to load products report company name.',
                    error,
                });
                setCompanyName('');
            });

        return () => {
            controller.abort();
        };
    }, [accessToken, aiProfileApi, isShown]);

    return companyName;
};
